export default "/_next/static/fonts/tt_norms_pro_light_italic-17bc8cccc910b9cda9fb8c869b57d966.woff";